// Copyright (c) 2016 Deere & Company

import RegistrationHistory from '@deere/cps-it.warranty-model-factory/lib/registration-history';
import t from 'tcomb';

const RegistrationHistoryList = t.list(RegistrationHistory, 'RegistrationHistoryList');

export const getDefaultState = () => new RegistrationHistoryList([]);

export default RegistrationHistoryList;



// WEBPACK FOOTER //
// ./src/product/details/state/registration-history.js